import { render, staticRenderFns } from "./MerchantConcurrentStatistics.vue?vue&type=template&id=c42884c8&"
import script from "./MerchantConcurrentStatistics.vue?vue&type=script&lang=ts&"
export * from "./MerchantConcurrentStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MerchantConcurrentStatistics.vue"
export default component.exports